(function () {
  var SCROLL_DELTA_MIN = 2;
  var NAV_CONTENT_TYPE = 'Shokz for Students Page Nav';

  function trackNavLinkClick(buttonName) {
    var label = (buttonName || '').trim();
    if (!label) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'select_content_category',
      event_parameters: {
        content_type: NAV_CONTENT_TYPE,
        button_name: label
      }
    });
  }

  function getNavLinkLabel(linkEl) {
    return linkEl && linkEl.textContent ? linkEl.textContent.trim() : '';
  }

  function getSiteHeader() {
    return document.querySelector('.site-header');
  }

  function getAnnouncement() {
    var announcement = document.querySelector('.announcement-wrapper');
    if (announcement && !announcement.classList.contains('hide')) {
      return announcement;
    }
    return document.querySelector('#shopify-section-announcement');
  }

  function getHeaderBottomOffset() {
    if (document.body.classList.contains('oeh-stu-nav-replace-header')) {
      return 0;
    }

    var siteHeader = getSiteHeader();
    if (siteHeader) {
      return Math.max(0, siteHeader.getBoundingClientRect().bottom);
    }

    var total = 0;
    var announcement = getAnnouncement();
    var header =
      document.querySelector('.header-wrapper') ||
      document.querySelector('#shopify-section-header') ||
      document.querySelector('[data-section-type="header-section"]');

    if (announcement) {
      total += announcement.offsetHeight;
    }
    if (header) {
      total += header.offsetHeight;
    }
    total -= 2;
    return total;
  }

  function isHeaderPinnedAtTop() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop <= 1) return false;

    var siteHeader = getSiteHeader();
    if (!siteHeader) return scrollTop > 1;

    var headerRect = siteHeader.getBoundingClientRect();
    var headerTop = parseFloat(window.getComputedStyle(siteHeader).top) || 0;

    return headerRect.top <= headerTop + 1;
  }

  function getScrollOffset(root) {
    var offset = getHeaderBottomOffset();
    var bar = root.querySelector('[data-oeh-stu-nav-bar]');

    if (root.classList.contains('is-visible') && bar) {
      offset += bar.offsetHeight;
    }

    return offset;
  }

  function normalizeTargetClass(targetClass) {
    return (targetClass || '').replace(/^\./, '').trim();
  }

  function getTargetElement(targetClass) {
    var normalizedClass = normalizeTargetClass(targetClass);
    if (!normalizedClass) return null;
    return document.querySelector('.' + CSS.escape(normalizedClass));
  }

  function getNavTargets(root) {
    var targets = [];

    root.querySelectorAll('[data-oeh-stu-nav-target]').forEach(function (link) {
      var targetClass = link.getAttribute('data-oeh-stu-nav-target');
      var section = getTargetElement(targetClass);
      if (!section) return;

      targets.push({
        link: link,
        section: section
      });
    });

    targets.sort(function (a, b) {
      var aTop = a.section.getBoundingClientRect().top + window.pageYOffset;
      var bTop = b.section.getBoundingClientRect().top + window.pageYOffset;
      return aTop - bTop;
    });

    return targets;
  }

  function setActiveNavLink(targets, activeIndex) {
    targets.forEach(function (item, index) {
      var isActive = index === activeIndex;
      item.link.classList.toggle('is-active', isActive);
      item.link.setAttribute('aria-current', isActive ? 'location' : 'false');
    });
  }

  function updateActiveNavLink(root) {
    var targets = root._navTargets;
    if (!targets || !targets.length) return;

    var offset = getScrollOffset(root);
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var activeIndex = 0;

    targets.forEach(function (item, index) {
      var sectionTop = item.section.getBoundingClientRect().top + scrollTop;
      if (scrollTop + offset >= sectionTop - 2) {
        activeIndex = index;
      }
    });

    setActiveNavLink(targets, activeIndex);
  }

  function refreshNavTargets(root) {
    root._navTargets = getNavTargets(root);
    updateActiveNavLink(root);
  }

  function scrollToSectionTarget(targetClass, root) {
    if (!targetClass) return false;

    var target = getTargetElement(targetClass);
    if (!target) return false;

    var top = target.getBoundingClientRect().top + window.pageYOffset - getScrollOffset(root);

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth'
    });

    return true;
  }

  function resolveNavClickTrigger(root, event) {
    var linkItem = event.target.closest('.section-open-eh-stu-nav__link-item');
    if (linkItem && root.contains(linkItem)) {
      var navLink = event.target.closest('.section-open-eh-stu-nav__link');
      if (navLink && linkItem.contains(navLink)) {
        return navLink;
      }
    }

    var button = event.target.closest('.section-open-eh-stu-nav__button[data-oeh-stu-nav-target]');
    if (button && root.contains(button)) {
      return button;
    }

    return null;
  }

  function initNavLinks(root) {
    root.addEventListener('click', function (event) {
      var trigger = resolveNavClickTrigger(root, event);
      if (!trigger) return;

      trackNavLinkClick(getNavLinkLabel(trigger));

      if (!trigger.hasAttribute('data-oeh-stu-nav-target')) return;

      event.preventDefault();
      scrollToSectionTarget(trigger.getAttribute('data-oeh-stu-nav-target'), root);

      if (root._navTargets) {
        var activeIndex = root._navTargets.findIndex(function (item) {
          return item.link === trigger;
        });
        if (activeIndex !== -1) {
          setActiveNavLink(root._navTargets, activeIndex);
        }
      }
    });
  }

  function setNavVisible(root, isVisible) {
    var bar = root.querySelector('[data-oeh-stu-nav-bar]');
    root.classList.toggle('is-visible', isVisible);
    root.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    document.body.classList.toggle('oeh-stu-nav-replace-header', isVisible);

    if (bar) {
      bar.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      bar.style.top = isVisible ? '0px' : '';
    }
  }

  function updateNavVisibility(root) {
    var bar = root.querySelector('[data-oeh-stu-nav-bar]');
    if (!bar) return;

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var lastScrollTop = root._lastScrollTop || 0;
    var scrollDelta = scrollTop - lastScrollTop;
    var scrollingDown = scrollDelta > SCROLL_DELTA_MIN;
    var headerPinned = isHeaderPinnedAtTop();
    var isVisible = root.classList.contains('is-visible');
    var shouldShow = isVisible;

    if (!headerPinned) {
      shouldShow = false;
    } else if (scrollingDown) {
      shouldShow = true;
    }

    root._lastScrollTop = scrollTop;

    if (shouldShow !== isVisible) {
      setNavVisible(root, shouldShow);
    } else if (shouldShow) {
      bar.style.top = '0px';
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.navInitialized === 'true') return;
    root.dataset.navInitialized = 'true';
    root._lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    var onScroll = function () {
      updateNavVisibility(root);
      updateActiveNavLink(root);
    };

    var onResize = function () {
      clearTimeout(root._navResizeTimer);
      root._navResizeTimer = setTimeout(function () {
        if (root.classList.contains('is-visible')) {
          var bar = root.querySelector('[data-oeh-stu-nav-bar]');
          if (bar) {
            bar.style.top = getHeaderBottomOffset() + 'px';
          }
        }
        updateNavVisibility(root);
        refreshNavTargets(root);
      }, 150);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    root._navOnScroll = onScroll;
    root._navOnResize = onResize;

    initNavLinks(root);
    refreshNavTargets(root);
    setNavVisible(root, false);
    updateNavVisibility(root);
  }

  function destroyRoot(root) {
    if (!root) return;

    if (root._navOnScroll) {
      window.removeEventListener('scroll', root._navOnScroll);
      delete root._navOnScroll;
    }
    if (root._navOnResize) {
      window.removeEventListener('resize', root._navOnResize);
      delete root._navOnResize;
    }
    if (root._navResizeTimer) {
      clearTimeout(root._navResizeTimer);
      delete root._navResizeTimer;
    }

    setNavVisible(root, false);
    root.classList.remove('is-visible');
    document.body.classList.remove('oeh-stu-nav-replace-header');
    root.setAttribute('aria-hidden', 'true');
    root.querySelectorAll('.section-open-eh-stu-nav__link.is-active').forEach(function (link) {
      link.classList.remove('is-active');
      link.setAttribute('aria-current', 'false');
    });
    delete root._navTargets;
    delete root._lastScrollTop;
    delete root.dataset.navInitialized;
  }

  function initAll() {
    document.querySelectorAll('[data-oeh-stu-nav-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-oeh-stu-nav-root]');
    if (!root) return;
    destroyRoot(root);
    initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-oeh-stu-nav-root]');
    if (!root) return;
    destroyRoot(root);
  });
})();
